<!-- ADQ看板 -->
<template>
<div>
	<div id="put-account" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;display: flex;align-items: center;">
		<div class="page-title" style="margin-right: 30px;margin-bottom: 16px;">腾讯ADQ看板</div>
		<a-tabs :activeKey="tab_key" type="card" @change="callback" :tabBarGutter="10">
			<a-tab-pane v-for="(item,index) in showTabData" :key="item.keys" :tab="item.name"></a-tab-pane>
		</a-tabs>
	</div>
	</div>	
		
	<div style="padding: 0 0 30px 0;">
		<router-view/>
	</div>
</div>
</template>

<script>
export default {
	name: 'ADQindex_',
	components: {
		
	},
	data() {
		return {
			tab_key: "1",
			body_width: 1600,
			table_scroll_width: 1600,
			
			tabData: [
				{name:"账户", keys: "1", urls:"/ADQzh", },
				{name:"计划", keys: "3", urls:"/ADQjh", },
				{name:"广告", keys: "5", urls:"/ADQgg", },
			],
			showTabData: [{name:"",}],
		}
	},
	mounted(){
		let that = this
		
		
		// console.log("路由地址",this.$route.fullPath);
		let page_path = this.$route.fullPath
		let tab_path = []
		
		// console.log("get_navData",JSON.parse(localStorage.getItem("get_navData")));
		let n_data = JSON.parse(localStorage.getItem("get_navData"))
		// 找出当前路径所在的vues数据。
		n_data.forEach((res,index)=>{
			if(res.child.length != 0){
				res.child.forEach((res_a,index_a)=>{
					if(res_a.child.length != 0){
						res_a.child.forEach((res_c,index_c)=>{
							
							res_c.vues.forEach((res_e,index_e)=>{
								if(res_e.vue_url == page_path){
									tab_path = res_c.vues
								}
							})
							
						})
					}
				})
				
			}
		})
		// console.log("tab_path",tab_path);
		let tt_data = []
		// 根据后端配置的顺序进行排序
		tab_path.forEach((res,index)=>{
			that.tabData.forEach((res_z,index_z)=>{
				if(res.vue_url == res_z.urls){
					tt_data.push(res_z)
				}
			})
		})
		// console.log("tt_data",tt_data);
		that.showTabData = tt_data
		
		
		function checkTab(urls){
			if(urls.indexOf("ADQzh") > -1){
				that.tab_key = "1"
			}
			else if(urls.indexOf("ADQjh") > -1){
				that.tab_key = "3"
			}
			else if(urls.indexOf("ADQgg") > -1){
				that.tab_key = "5"
			}
		}
		// 保证页面刷新能更新tab选中状态
		checkTab(that.$route.fullPath)
		
		that.body_width = document.body.clientWidth // 筛选条件大盒子的宽度
		// 接收粘性定位用的参数
		this.$bus.$on('stickyData',(e)=>{
		    console.log('ADQindex',e)
			that.table_scroll_width = e
		})
		
		
		// 接收子页面传过来的路径
		this.$bus.$on('tabPath',(e)=>{
		    console.log('ADQindex-tabPath-----',e)
			// that.table_scroll_width = e
			checkTab(e)
		})
	},
	// 销毁生命周期
	beforeDestroy(){
	    this.$bus.$off('stickyData') // 销毁，减轻vue压力
		// 如果不销毁，后面可能会重复执行多次，因为没有销毁，所以触发的会一直在
		this.$bus.$off('tabPath') // 销毁，减轻vue压力
	},
	methods:{
		// 切换tab
		callback(e){
			console.log(e);
			if(e == "1"){ // 账户
				this.tab_key = e
				this.$router.push({path: '/ADQzh'})
			}
			else if(e == "3"){ // 计划
				this.tab_key = e
				this.$router.push({path: '/ADQjh'})
			}
			else if(e == "5"){ // 广告
				this.tab_key = e
				this.$router.push({path: '/ADQgg'})
			}
		}
	}
}
</script>

<style scoped>
</style>